module.exports = __webpack_public_path__ + "img/dc-logo-white.84736161.svg";